import defaultTransition from './default';
import programEventTransition from './program-event';
import eventProgramTransition from './event-program';

export default [defaultTransition, programEventTransition, eventProgramTransition];
